import { Entity } from '../data-objects/entity'

export function cloneEntity(e: Entity) {
  const cloned = { ...e }
  const fields = { ...e.fields }
  Object.keys(fields).forEach((key) => {
    const value = fields[key]
    if (value && (value as any).clone) {
      fields[key] = value.clone()
    }
  })
  cloned.fields = fields
  return cloned
}
